export { effectiveMaintenance, maintenanceEndsAt } from '@mybusinessmate/schema';

export const AUTO_OFF_CHOICES = [
  { id: '1h', label: 'In 1 hour', hours: 1 },
  { id: '2h', label: 'In 2 hours', hours: 2 },
  { id: '4h', label: 'In 4 hours', hours: 4 },
  { id: 'never', label: 'Never, I’ll turn it off myself', hours: null },
] as const;

const CLOCK = new Intl.DateTimeFormat('en-IN', { hour: 'numeric', minute: '2-digit', hour12: true });

/** "In 1 hour (1:00 AM)" for the "Turn off automatically" picker. */
export function autoOffLabel(choice: (typeof AUTO_OFF_CHOICES)[number], now: Date = new Date()): string {
  if (choice.hours === null) return choice.label;
  const at = new Date(now.getTime() + choice.hours * 3_600_000);
  return `${choice.label} (${CLOCK.format(at).toUpperCase()})`;
}

/** Date-time-local ("2026-10-25T00:00") -> an ISO string with the viewer's offset, or undefined if empty/invalid. */
export function localInputToIso(value: string): string | undefined {
  if (!value) return undefined;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
}
